"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionSelectionContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const licenses_1 = require("@completeanatomy/licenses");
const storage_1 = require("@completeanatomy/storage");
const user_1 = require("@completeanatomy/user");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const region_selection_image_svg_1 = __importDefault(require("../../assets/images/region-selection-image.svg"));
const withDelayedAppearance_1 = require("../../hocs/withDelayedAppearance");
const SurveyPageContentTemplate_1 = require("../../templates/SurveyPageContentTemplate/SurveyPageContentTemplate");
const utils_1 = require("../../utils");
const RegionSelection_1 = require("../RegionSelection/RegionSelection");
// eslint-disable-next-line max-lines-per-function
function RegionSelectionContent() {
    const [country, setCountry] = (0, react_1.useState)(null);
    const [region, setRegion] = (0, react_1.useState)(bridge_schema_1.AppRegion.Unknown);
    const [isActiveContinue, setIsActiveContinue] = (0, react_1.useState)(false);
    const [showWarning, setShowWarning] = (0, react_1.useState)(false);
    const [showRegionSelect, setShowRegionSelect] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const bridge = (0, bridge_1.useBridge)();
    const storage = (0, storage_1.useStorageService)();
    const deviceRegion = (0, device_1.useDeviceRegion)();
    const devicePlatform = (0, device_1.usePlatform)();
    const systemVersion = (0, device_1.useSystemVersion)();
    const user = (0, user_1.useUser)();
    const userLicenses = (0, licenses_1.useUserLicenses)();
    //const analytics = useAnalytics();
    /**
     * On app launch + component mount:
     * If region has been selected or if Android => Continue Onboarding flow.
     */
    const isDeviceRegionSelected = deviceRegion !== undefined && deviceRegion !== bridge_schema_1.AppRegion.Unknown;
    const isAndroid = devicePlatform.isAndroid;
    (0, react_1.useEffect)(() => {
        if (isDeviceRegionSelected || isAndroid) {
            setShowRegionSelect(false);
            navigateToNextPage();
        }
        else {
            setShowRegionSelect(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deviceRegion]);
    // eslint-disable-next-line max-lines-per-function
    const navigateToNextPage = () => __awaiter(this, void 0, void 0, function* () {
        Promise.all([
            storage === null || storage === void 0 ? void 0 : storage.get('isPrivacyPolicyAccepted'),
            storage === null || storage === void 0 ? void 0 : storage.get('pushNotificationsDeclined'),
            storage === null || storage === void 0 ? void 0 : storage.get('newUserSurvey'),
            storage === null || storage === void 0 ? void 0 : storage.get('shouldShowUserSurvey'),
            storage === null || storage === void 0 ? void 0 : storage.get('shouldShowRedeemCodePopover'),
            storage === null || storage === void 0 ? void 0 : storage.get('shouldShowSurveyCompleted'),
            storage === null || storage === void 0 ? void 0 : storage.get('shouldShowSubscriptionSheet'),
            storage === null || storage === void 0 ? void 0 : storage.get('shouldCallRestorePurchase'),
            storage === null || storage === void 0 ? void 0 : storage.get('shouldCallOnBuy'),
        ]).then(([privacyPolicyAccepted, pushNotificationsDeclined, cachedUserSurvey, showProfileSurvey, showRedeemCodePopover, showSurveyCompleted, showSubscriptionSheet, callRestorePurchase, callOnBuy,]) => {
            const currentRegion = deviceRegion !== bridge_schema_1.AppRegion.Unknown ? deviceRegion : region;
            const isPNEligible = (0, utils_1.isPushNotificationsEligible)(devicePlatform, systemVersion, currentRegion);
            const storageData = {
                currentRegion,
                privacyPolicyAccepted,
                pushNotificationsDeclined,
                pushNotificationsEligible: isPNEligible,
                cachedUserSurvey,
                showProfileSurvey,
                showRedeemCodePopover,
                showSurveyCompleted,
                showSubscriptionSheet,
                callRestorePurchase,
                callOnBuy,
                user,
                userLicenses,
                storage,
            };
            const onboardingRoute = (0, utils_1.getOnboardingRoute)(storageData);
            /** REGION SELECTION ===
             * New launch users:
             *  - deviceRegion will not be set, continue only when useState's region updates.
             *
             * Existing users:
             *  - Should have deviceRegion set. Continue onboarding.
             */
            if (!isDeviceRegionSelected && !isAndroid) {
                bridge === null || bridge === void 0 ? void 0 : bridge.selectAppRegion(region);
            }
            /** AFTER LOGIN ===
             * navigateBack is set when user logs in through Settings/Models/Store.
             * If true -> navigates back to prior page before auth.
             */
            // @ts-ignore
            const navigateBack = window.navigateBack === true;
            if (navigateBack && onboardingRoute === '/hub') {
                // @ts-ignore
                window.navigateBack = undefined;
                return navigate(-1);
            }
            else {
                return navigate(`${onboardingRoute}`);
            }
        });
    });
    const onCountrySelect = (value) => {
        setShowWarning(false);
        setCountry(value);
        setIsActiveContinue(true);
        const selectedRegion = (value === null || value === void 0 ? void 0 : value.code) === 'CN' ? bridge_schema_1.AppRegion.China : bridge_schema_1.AppRegion.ROW;
        setRegion(selectedRegion);
    };
    const onContinue = () => {
        if (!isActiveContinue) {
            setShowWarning(true);
            return;
        }
        if (country) {
            //analytics.log(analytics.EventName); //TODO: add analytics.
            navigateToNextPage();
        }
    };
    if (showRegionSelect) {
        return ((0, jsx_runtime_1.jsx)(StyledPageContent, { Image: region_selection_image_svg_1.default, content: (0, jsx_runtime_1.jsx)(RegionSelection_1.RegionSelection, { country: country, setCountry: setCountry, onCountrySelect: onCountrySelect, isActiveContinue: isActiveContinue, setIsActiveContinue: setIsActiveContinue, onContinue: onContinue, showWarning: showWarning }), "data-e2e": 'RegionSelectionContent_StyledPageContent' }));
    }
    else {
        //To prevent unnecessary flickering when region select is called.
        return ((0, jsx_runtime_1.jsx)("button", { style: { position: 'absolute', opacity: 0, height: 0, width: 0 }, "aria-hidden": "true", "data-e2e": 'RegionSelectionContent_button', children: "Hidden Region Select Element" }));
    }
}
exports.RegionSelectionContent = RegionSelectionContent;
exports.default = (0, storage_1.withStorageProvider)((0, withDelayedAppearance_1.withDelayedAppearance)(RegionSelectionContent, 300, 200));
const StyledPageContent = (0, styled_components_1.default)(SurveyPageContentTemplate_1.SurveyPageContentTemplate) `
  overflow-x: hidden;
`;
